module.exports = __webpack_public_path__ + "img/applicationresults_ry02.c3f99960.png";